import { render, staticRenderFns } from "./ComCampaignCreate.vue?vue&type=template&id=628ccff1&scoped=true&"
import script from "./ComCampaignCreate.vue?vue&type=script&lang=js&"
export * from "./ComCampaignCreate.vue?vue&type=script&lang=js&"
import style0 from "./ComCampaignCreate.vue?vue&type=style&index=0&id=628ccff1&scoped=true&lang=sass&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "628ccff1",
  null
  
)

export default component.exports